import { render, staticRenderFns } from "./FurnitureDetails.vue?vue&type=template&id=f5fbad00&"
import script from "./FurnitureDetails.vue?vue&type=script&lang=js&"
export * from "./FurnitureDetails.vue?vue&type=script&lang=js&"
import style0 from "./FurnitureDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports